import React, { useEffect, useState, useContext } from "react";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import Stack from "@mui/material/Stack";
import Chip from "@mui/material/Chip";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import MyContext from "../../../context/MyContext";

const GuidesOptions = (props) => {
  const {
    enableAutoGuides,
    setenableAutoGuides,
    setenableGrid,
    enableGrid,
    setenableRuler,
    enableRuler,
  } = useContext(MyContext);
  return (
    <>
      <Dialog
        open={props.open}
        onClose={() => props.setguideOpen(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle
          id="alert-dialog-title mr-4"
          style={{ marginRight: "100px" }}
        >
          {"Guide Options and Shortcut Keys"}
          <IconButton
            onClick={() => props.setguideOpen(false)}
            style={{ position: "absolute", right: "10px", top: "10px" }}
            aria-label="Close"
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent>
          <FormGroup>
            <Stack justifyContent="space-between" direction="row" spacing={2}>
              <FormControlLabel
                control={
                  enableAutoGuides ? (
                    <Checkbox
                      checked
                      onClick={() => setenableAutoGuides(false)}
                    />
                  ) : (
                    <Checkbox onClick={() => setenableAutoGuides(true)} />
                  )
                }
                label="Enable auto helping guides"
              />
              <Chip size="small" label="Shift + G" className="mt-2" />
            </Stack>
            <Stack justifyContent="space-between" direction="row" spacing={2}>
              <FormControlLabel
                control={
                  enableGrid ? (
                    <Checkbox checked onClick={() => setenableGrid(false)} />
                  ) : (
                    <Checkbox onClick={() => setenableGrid(true)} />
                  )
                }
                label="Enable grid"
              />
              <Chip size="small" label="Shift + E" className="mt-2" />
            </Stack>

            <Stack justifyContent="space-between" direction="row" spacing={2}>
              <FormControlLabel
                control={
                  enableRuler ? (
                    <Checkbox checked onClick={() => setenableRuler(false)} />
                  ) : (
                    <Checkbox onClick={() => setenableRuler(true)} />
                  )
                }
                label="Enable ruler"
              />
              <Chip size="small" label="Shift + R" className="mt-2" />
            </Stack>
          </FormGroup>
        </DialogContent>
        {/* <DialogActions>
          <Button>Disagree</Button>
        </DialogActions> */}
      </Dialog>
    </>
  );
};

export default GuidesOptions;
